var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.331h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#496e2d",
  d: "M0 85.331h170.663v341.337H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M341.337 85.331H512v341.337H341.337zm-85.338 123.173l11.787 36.278h38.147l-30.86 22.423 11.787 36.28-30.861-22.423-30.861 22.423 11.789-36.28-30.861-22.423h38.146z",
  fill: "#ffda44"
})));

export default SvgCm;